export default "__VITE_ASSET__DeJAANOf__"